// PN-8 (T-430) — « Mettre de côté » : à la place de « Supprimer / Archiver ». Rien n'est effacé ; la RAISON est obligatoire
// (elle est gardée sur le dossier et visible dans la grille). Le dialogue ne fait aucun appel : il rend la raison à `onConfirm`.
import { useState } from "react";
import { Button } from "../../../components/ui/button";
import { Textarea } from "../../../components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../../../components/ui/dialog";

export function MettreDeCoteDialog({ ouvert, nombre = 1, onFermer, onConfirm }) {
  const [raison, setRaison] = useState("");
  const fermer = () => { setRaison(""); onFermer(); };
  const confirmer = () => { const r = raison.trim(); if (!r) return; onConfirm(r); setRaison(""); };
  const pluriel = nombre > 1;
  return (
    <Dialog open={ouvert} onOpenChange={(o) => { if (!o) fermer(); }}>
      <DialogContent data-testid="mettre-de-cote-dialog" className="max-w-md">
        <DialogHeader>
          <DialogTitle>{pluriel ? `Mettre ${nombre} dossiers de côté` : "Mettre ce dossier de côté"}</DialogTitle>
          <DialogDescription>
            {pluriel ? "Ces dossiers disparaissent" : "Ce dossier disparaît"} des listes, mais rien n'est effacé : on peut {pluriel ? "les" : "le"} retrouver
            avec « Mis de côté » et {pluriel ? "les" : "le"} remettre en place.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-1">
          <label htmlFor="mise-de-cote-raison" className="text-sm" style={{ color: "var(--oh-text)" }}>Raison (obligatoire)</label>
          <Textarea id="mise-de-cote-raison" data-testid="mise-de-cote-raison" value={raison} onChange={(e) => setRaison(e.target.value)}
            placeholder="Par exemple : le client a renoncé, doublon du dossier 12…" />
        </div>
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={fermer} data-testid="mise-de-cote-annuler">Annuler</Button>
          <Button onClick={confirmer} disabled={!raison.trim()} data-testid="mise-de-cote-confirmer">Mettre de côté</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

/** Appelle l'archivage existant avec la raison. Retourne { ok, fail }. `entetes` : getAuthHeaders(...). */
export async function mettreDeCote(ids, raison, { api, entetes }) {
  let ok = 0, fail = 0;
  for (const id of ids) {
    try {
      const res = await fetch(`${api}/api/metier/dossiers/${id}/archiver`, {
        method: "POST", headers: { "Content-Type": "application/json", ...entetes }, credentials: "include",
        body: JSON.stringify({ raison }),
      });
      if (res.ok) ok += 1; else fail += 1;
    } catch { fail += 1; }
  }
  return { ok, fail };
}
